<div class="page-with-shadow">
    <app-page-header [title]="pageTitle" [description]="pageDescription">
    </app-page-header>

    <div class="container" *ngIf="summary">
  <div class="row g-3 mt-3">
    <!-- Projects Card -->
    <div class="col-md-4">
      <mat-card class="h-100">
        <mat-card-header>
          <mat-card-title>
            <a routerLink="/projects" class="d-flex align-items-center text-decoration-none">
              <mat-icon class="me-2">vertical_split</mat-icon>
              <span class="fw-bold">Projects</span>
            </a>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-divider></mat-divider>
          <div class="d-flex justify-content-between">
            <div class="w-100 pe-2">
              <mat-list>
                <mat-list-item><b>Total</b>: {{ summary.ProjectSummary.Total }}</mat-list-item>
                <mat-list-item><b>Archived</b>: {{ summary.ProjectSummary.Archived }}</mat-list-item>
              </mat-list>
            </div>
            <mat-divider [vertical]="true"></mat-divider>
            <div class="w-100 ps-2">
              <mat-list>
                <mat-list-item *ngFor="let item of summary.ProjectSummary.StatusSummary">
                  <b>{{ item.Name }}</b>: {{ item.ItemsCount }}
                </mat-list-item>
              </mat-list>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Equipment Card -->
    <div class="col-md-4">
      <mat-card class="h-100">
        <mat-card-header>
          <mat-card-title>
            <a routerLink="/equipments" class="d-flex align-items-center text-decoration-none">
              <mat-icon class="me-2">view_list</mat-icon>
              <span class="fw-bold">Equipment</span>
            </a>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-divider></mat-divider>
          <div class="d-flex justify-content-between">
            <div class="w-100 pe-2">
              <mat-list>
                <mat-list-item><b>Total</b>: {{ summary.EquipmentSummary.Total }}</mat-list-item>
                <mat-list-item><b>Archived</b>: {{ summary.EquipmentSummary.Archived }}</mat-list-item>
                <mat-list-item><b>Spare</b>: {{ summary.EquipmentSummary.Spare }}</mat-list-item>
              </mat-list>
            </div>
            <mat-divider [vertical]="true"></mat-divider>
            <div class="w-100 ps-2">
              <mat-list>
                <mat-list-item *ngFor="let item of summary.EquipmentSummary.StatusSummary">
                  <b>{{ item.Name }}</b>: {{ item.ItemsCount }}
                </mat-list-item>
              </mat-list>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Purchase Orders Card -->
    <div class="col-md-4">
      <mat-card class="h-100">
        <mat-card-header>
          <mat-card-title>
            <a routerLink="/purchase-orders" class="d-flex align-items-center text-decoration-none">
              <mat-icon class="me-2">assignment</mat-icon>
              <span class="fw-bold">Purchase Orders</span>
            </a>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-divider></mat-divider>
          <mat-list>
            <mat-list-item><b>Total</b>: {{ summary.PurchaseOrderSummary.Total }}</mat-list-item>
            <mat-list-item><b>Archived</b>: {{ summary.PurchaseOrderSummary.Archived }}</mat-list-item>
          </mat-list>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>